import api from './api';

const resourceCalendarService = {
  getAll: async (params = {}) => {
    const response = await api.get('/resource-calendar', { params });
    return response.data;
  },
  getFeed: async (params = {}) => {
    const response = await api.get('/resource-calendar/feed', { params });
    return response.data;
  },
  getStats: async () => {
    const response = await api.get('/resource-calendar/stats');
    return response.data;
  },
  getById: async (id) => {
    const response = await api.get(`/resource-calendar/${id}`);
    return response.data;
  },
  create: async (data) => {
    const response = await api.post('/resource-calendar', data);
    return response.data;
  },
  update: async (id, data) => {
    const response = await api.put(`/resource-calendar/${id}`, data);
    return response.data;
  },
  remove: async (id) => {
    const response = await api.delete(`/resource-calendar/${id}`);
    return response.data;
  }
};

export default resourceCalendarService;
